import { render, staticRenderFns } from "./AskACoach.vue?vue&type=template&id=3f3b895e&scoped=true"
import script from "./AskACoach.vue?vue&type=script&lang=js"
export * from "./AskACoach.vue?vue&type=script&lang=js"
import style0 from "./AskACoach.vue?vue&type=style&index=0&id=3f3b895e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b895e",
  null
  
)

export default component.exports